import { useEffect } from 'react';

import {
  CutoffDateDayType,
  CutoffDateMonthType,
  PaymentDateDayType,
  PaymentDateMonthType,
} from '@models/next/Partner';
import { type MobxZodField, getDecodeResultOr } from '@monoid-dev/mobx-zod-form';
import { ZodNullable, ZodNumber, ZodOptional } from 'zod';

export interface paymentAutoFillOptions {
  monthField: MobxZodField<typeof PaymentDateMonthType>;
  selectedDayField: MobxZodField<ZodOptional<ZodNullable<ZodNumber>>>;
  dayField: MobxZodField<typeof PaymentDateDayType>;
}

export const usePaymentAutoFill = (options: paymentAutoFillOptions) => {
  const { monthField, selectedDayField, dayField } = options;

  const month = getDecodeResultOr(monthField.decodeResult, '');
  const day = getDecodeResultOr(dayField.decodeResult, '');

  useEffect(() => {
    if (month === PaymentDateMonthType.enum.請求毎) {
      dayField.setOutput(PaymentDateDayType.enum.請求);
    } else {
      if (day === PaymentDateDayType.enum.請求) {
        dayField.setOutput(PaymentDateDayType.Enum.月末払);
      }
    }
  }, [month]);

  useEffect(() => {
    if (day === PaymentDateDayType.enum.請求) {
      monthField.setOutput(PaymentDateMonthType.enum.請求毎);
    } else {
      if (month === PaymentDateMonthType.enum.請求毎) {
        monthField.setOutput(PaymentDateMonthType.enum.当月);
      }
    }

    if (day !== PaymentDateDayType.enum.日払) {
      selectedDayField.setOutput(null);
    }
  }, [day]);

  return {
    dateDisabled: day !== PaymentDateDayType.enum.日払,
  };
};

export interface CutoffAutoFillOptions {
  monthField: MobxZodField<typeof CutoffDateMonthType>;
  selectedDayField: MobxZodField<ZodOptional<ZodNullable<ZodNumber>>>;
  dayField: MobxZodField<typeof CutoffDateDayType>;
}

export const useCutoffAutoFill = (options: CutoffAutoFillOptions) => {
  const { monthField, selectedDayField, dayField } = options;

  const month = getDecodeResultOr(monthField.decodeResult, '');
  const day = getDecodeResultOr(dayField.decodeResult, '');

  useEffect(() => {
    if (month === CutoffDateMonthType.enum.請求毎) {
      dayField.setOutput(CutoffDateDayType.enum.請求);
    } else {
      if (day === CutoffDateDayType.enum.請求) {
        dayField.setOutput(CutoffDateDayType.Enum.月末締);
      }
    }
  }, [month]);

  useEffect(() => {
    if (day === CutoffDateDayType.enum.請求) {
      monthField.setOutput(CutoffDateMonthType.enum.請求毎);
    } else {
      if (month === CutoffDateMonthType.enum.請求毎) {
        monthField.setOutput(CutoffDateMonthType.enum.当月);
      }
    }

    if (day !== CutoffDateDayType.enum.日締) {
      selectedDayField.setOutput(null);
    }
  }, [day]);

  return {
    dateDisabled: day !== CutoffDateDayType.enum.日締,
  };
};
